import { Button } from "@mui/material";
import styles from "../css/InstallOnAllDevices.module.css";
import InstallImage from "../../../images/install.svg";
import { TailSpin } from "react-loader-spinner";
import { useDispatch } from "react-redux";
import { initialize } from "../../../common/state/Slices/InstallOnAllDeviceSlice";
import { useAppSelector } from "../../../common/state/hooks";
import { RootState } from "../../../common/state";
import { GadgetDaoFactory } from "../../Home/components/gadgets/GadgetRepository";
import { InstallGadgetOnDeviceRequest } from "../../../helper/cloudcore/request/models/events";
import { notify } from "../../../common/state/Slices/NotificationSlice";
import { CloudCoreFactory } from "../../../helper/cloudcore/factory";
import { FlattenedGadget } from "../../../models/GadgetModel";
import { useEffect, useState } from "react";
import { getGPKUrl } from "../../../helper/utils";
interface InstallOnAllDevicesButtonProps {
    displayGadget: FlattenedGadget,
}

export const InstallOnAllDevicesButton = ({displayGadget} : InstallOnAllDevicesButtonProps) => {
    const dispatch = useDispatch();
    const cloudCoreClient = CloudCoreFactory.getInstance();
    const connectedDeviceList = useAppSelector((state: RootState) => state.connectedDeviceSlice.deviceList);
    const onlineDevices = connectedDeviceList.filter((it) => it.online);
    const isAnyDeviceOnline = onlineDevices.length > 0;
    const allDeviceData = useAppSelector((state: RootState) => state.installOnAllDeviceSlice.status);
    const [isInstallationInProgress, setIsInstallationInProgress] = useState<boolean>(false);

    useEffect(() => {
        if(allDeviceData && displayGadget.id in allDeviceData) {
            const gadgetData = allDeviceData[displayGadget.id];
            const currentRemainingDevices = gadgetData.remainingDevices;
            setIsInstallationInProgress(currentRemainingDevices && currentRemainingDevices.length > 0);
        }
    }, [allDeviceData, displayGadget.id]);
    
    const handleInstallOnAll = () => {
        dispatch(
            initialize({
                gadgetId: displayGadget.id,
                remainingDevices: onlineDevices.map(it => it.id)
            })
        );
        const onlineDevicesConnectionId = onlineDevices.map(it => it.connection_id);
        const gadgeturlRequest = getGPKUrl(displayGadget);

        GadgetDaoFactory.getGadgetRepository()
        .getPreSignedUrl(displayGadget.id, gadgeturlRequest)
        .then((result) => {
            const request = new InstallGadgetOnDeviceRequest(onlineDevices[0].user_id, result.url, onlineDevicesConnectionId, displayGadget.size, displayGadget.id);
            cloudCoreClient.sendEvent(request);
        })
        .catch(() => {
            const errorMessage = "You are not authorized to install this gadget";
            dispatch(
                notify({
                    message: errorMessage,
                    severity: "error"
                })
            );
            dispatch(
                initialize({
                    gadgetId: displayGadget.id,
                    remainingDevices: null
                })
            );
            console.error(errorMessage);
        });
    };

    return (
        <Button
            variant="outlined" 
            data-testid={"install-on-all-button"}
            className={(isAnyDeviceOnline ? styles.online : styles.offline) + " " + styles.installAllButton}
            onClick={handleInstallOnAll}
            disabled={isInstallationInProgress}
        >
            <img
                data-testid={"install-on-all-button-icon"}
                src={InstallImage} 
                alt="install all icon"
                style={{
                    display: isInstallationInProgress ? "none": "block"
                }}
            />
            <TailSpin
                visible={isInstallationInProgress}
                height="30"
                width="30"
                color="#fff"
                ariaLabel="tail-spin-loading"
                radius="3"
                wrapperStyle={{}}
                wrapperClass=""
            />
            {isInstallationInProgress ? "Installing" : "Install on all devices"}
        </Button>
    )
}